import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ExchangeRate, ExchangeRateCreate, ExchangeRateFilter } from '../data/exchangeRate';

export function createExchangeRateService(client: AxiosInstance) {
  return createCrudService<ExchangeRate, ExchangeRateCreate, ExchangeRateFilter>(
    client,
    '/accounting/ExchangeRate',
    'id',
  );
}

export type ExchangeRateService = CrudService<ExchangeRate, ExchangeRateCreate, ExchangeRateFilter>;
